module.exports = __webpack_public_path__ + "static/img/2.09cc66e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/2.png
// module id = B8/D
// module chunks = 0